import { Box, Button, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { useExecuteUserDataDeletion } from '../api';
import { MetaAuditLog } from '../types';
import { formatDate } from '../utils';

type ConfirmationSectionProps = {
  chatIds: string[];
  file: File | null;
};

export const ConfirmationSection = ({ chatIds, file }: ConfirmationSectionProps) => {
  const [result, setResult] = useState<MetaAuditLog | null>(null);
  const { mutate: executeUserDataDeletion } = useExecuteUserDataDeletion();

  const handleConfirmDeletion = () => {
    if (!chatIds.length) {
      return;
    }

    const fileName = file?.name || `${formatDate(new Date())}.csv`;

    executeUserDataDeletion(
      { chatIds, fileName },
      {
        onSuccess: ({ log }: { log: MetaAuditLog }) => {
          setResult(log);
        },
        onError: () => {
          setResult(null);
        },
      }
    );
  };

  return (
    <Stack>
      <Button color="red" disabled={!file} onClick={handleConfirmDeletion}>
        Confirm deletion
      </Button>

      {result && (
        <Box mt="sm" p="sm">
          <Stack py="lg">
            <Text>Status: {result.status}</Text>
            <Text>File name: {result.fileName}</Text>
            <Text>IDs in file: {result.idsInFile}</Text>
          </Stack>
          <Stack py="lg">
            <Text>Matched Dialogs: {result.matchedDialogsCount}</Text>
            <Text>Matched Messages: {result.matchedMessagesCount}</Text>
            <Text>Matched Total: {result.matchedDialogsCount + result.matchedMessagesCount}</Text>
          </Stack>
          <Stack py="lg">
            <Text>Deleted Dialogs: {result.deletedDialogsCount}</Text>
            <Text>Deleted Messages: {result.deletedMessagesCount}</Text>
            <Text>Deleted Total: {result.deletedDialogsCount + result.deletedMessagesCount}</Text>
          </Stack>
        </Box>
      )}
    </Stack>
  );
};
